import component from "./ProfileNewPastAttention.vue"

import wrapVueComponent from "@/utils/wrapVueComponent"
const componentName = "StudentProfileNewPastAttention"

export default wrapVueComponent(componentName, component)
